/**
 * @fileoverview Public surface of @puffin-core/app-catalog (CJS).
 *
 * The ONE app catalog vocabulary and its pure rules (APP-ENTITLEMENT-001): which apps exist, which are anchors,
 * what each attaches to, the capability keys each grants, its pricing model and its size dimensions — and the
 * arithmetic every surface shares. Prices are never here.
 *
 * Consumed by:
 *   - `@puffin-core/app-entitlements` (the server: resolver, gate, routers, billing engine)
 *   - `@puffin-core/account-apps-ui` (the Billing page and the switcher tiles)
 *   - the signup wizard's basket and `@puffin-core/marketing-shell`'s pricing section (browser, through the
 *     generated ESM half)
 *
 * @module @puffin-core/app-catalog
 */

'use strict';

const vocabulary = require('./vocabulary');
const refusal = require('./refusal');
const catalog = require('./catalog');
const heldCapabilities = require('./rules/heldCapabilities');
const trial = require('./rules/trial');
const proration = require('./rules/proration');
const caps = require('./rules/caps');
const anchor = require('./rules/anchor');
const pricing = require('./rules/pricing');
const quoteBasket = require('./rules/quoteBasket');
const capabilityMapping = require('./rules/capabilityMapping');
const publicCatalog = require('./rules/publicCatalog');

module.exports = {
  ...vocabulary,
  ...refusal,
  ...catalog,
  ...heldCapabilities,
  ...trial,
  ...proration,
  ...caps,
  ...anchor,
  ...pricing,
  ...quoteBasket,
  ...capabilityMapping,
  ...publicCatalog,
};
